import Typography from '@mui/material/Typography';
import React from 'react';
import errTranscript from './event-err-transcriptor';
import { momentFormat } from '#helper';

export default function (data, account, formatType) {
  const description = typeof data.description === 'string' ? data.description : '';
  return (
    <>
      <Typography color="textSecondary" className="time">
        {momentFormat(data.timestamp, account, formatType || 'dateTimePartial')}
      </Typography>
      <Typography component="p">{description}</Typography>
      {data.identifier === 'err' && (
        <Typography component="p">
          {`${errTranscript(
            data.details
          )}`}
        </Typography>
      )}
    </>
  );
}
